import { Group, Text, Tooltip } from '@mantine/core';
import { upperFirst } from '@mantine/hooks';

import LengthIcon from '@/assets/icons/password/length.svg';
import LowerCaseIcon from '@/assets/icons/password/lower_case.svg';
import UpperCaseIcon from '@/assets/icons/password/upper_case.svg';
import DigitsIcon from '@/assets/icons/password/digits.svg';
import SpecialIcon from '@/assets/icons/password/special_chars.svg';
import classes from './Signals.module.css';

interface PasswordComplexityProps {
  contains_digit: boolean;
  contains_lowercase: boolean;
  contains_special: boolean;
  contains_uppercase: boolean;
  length_chars: number;
  complexity: string;
}

const PasswordComplexity = ({
  contains_uppercase: containsUpperCase,
  contains_lowercase: containsLowerCase,
  contains_digit: containsDigit,
  contains_special: containsSpecial,
  length_chars: length,
  complexity,
}: PasswordComplexityProps) => {
  const width = 30;
  const height = 30;

  const tooltipLabel = (label: string, condition: boolean) =>
    condition ? `It contains ${label}` : `Does not contains ${label}`;

  return (
    <Group gap={5} align="center">
      <Text>{upperFirst(complexity)}</Text>

      <Group gap={5}>
        <Tooltip label={tooltipLabel('upper case', containsUpperCase)} multiline maw={220}>
          <span
            className={`${classes.passwordAttribute} ${!containsUpperCase ? classes.fail : ''}`}
          >
            <UpperCaseIcon width={width} height={height} />
          </span>
        </Tooltip>

        <Tooltip label={tooltipLabel('lower case', containsLowerCase)} multiline maw={220}>
          <span
            className={`${classes.passwordAttribute} ${!containsLowerCase ? classes.fail : ''}`}
          >
            <LowerCaseIcon width={width} height={height} />
          </span>
        </Tooltip>

        <Tooltip label={tooltipLabel('digits', containsDigit)} multiline maw={220}>
          <span className={`${classes.passwordAttribute} ${!containsDigit ? classes.fail : ''}`}>
            <DigitsIcon width={width} height={height} />
          </span>
        </Tooltip>

        <Tooltip label={tooltipLabel('special characters', containsSpecial)} multiline maw={220}>
          <span className={`${classes.passwordAttribute} ${!containsSpecial ? classes.fail : ''}`}>
            <SpecialIcon width={width} height={height} />
          </span>
        </Tooltip>

        <Tooltip
          label={
            length < 8 ? 'Length shorter than 8 characters' : 'Length longer than 8 characters'
          }
          multiline
          maw={220}
        >
          <span className={`${classes.passwordAttribute} ${length < 8 ? classes.fail : ''}`}>
            <LengthIcon width={width} height={height} />
          </span>
        </Tooltip>
      </Group>
    </Group>
  );
};

export default PasswordComplexity;
